import type { ReactNode } from "react";
import { ProtectedShell } from "@/features/auth/ProtectedShell";
import { AdminTabs } from "@/components/AdminTabs";

interface AdminShellProps {
  children: ReactNode;
}

export function AdminShell({ children }: AdminShellProps) {
  return (
    <ProtectedShell requireRole="admin">
      <AdminTabs />
      {children}
    </ProtectedShell>
  );
}
